import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { logoutUser } from "../../features/auth/authSlice"

// Role-based idle timeouts (ms)
const ROLE_IDLE_TIMEOUTS = {
  admin: 60 * 60 * 1000, //10 minutes
  manager: 30 * 60 * 1000, //10 minutes
  accountant: 30 * 60 * 1000, //10 minutes
  cashier: 15 * 60 * 1000 //15 minutes
}

function IdleLogout({ children }) {
  const dispatch = useDispatch()

  useEffect(() => {
    console.log("IdleLogout mounted")

    let interval

    const clearAuthAndLogout = () => {
      console.log("AUTO LOGOUT TRIGGERED")
      dispatch(logoutUser())
      window.location.href = "/login"
    }

    const getTimeout = () => {
      const role = (localStorage.getItem("role") || "").toLowerCase().trim()
      return ROLE_IDLE_TIMEOUTS[role] || 30 * 60 * 1000
    }

    const ensureLastActivity = () => {
      if (!localStorage.getItem("last_activity")) {
        localStorage.setItem("last_activity", Date.now().toString())
      }
    }

    const checkIdleTime = () => {
      const token = localStorage.getItem("token")
      if (!token) return

      ensureLastActivity()

      const lastActivity = Number(localStorage.getItem("last_activity"))
      const timeout = getTimeout()
      const idleTime = Date.now() - lastActivity

      console.log({
        role: localStorage.getItem("role"),
        idleSeconds: Math.floor(idleTime / 1000),
        timeoutSeconds: Math.floor(timeout / 1000)
      })

      if (idleTime >= timeout) {
        clearAuthAndLogout()
      }
    }

    const updateActivity = () => {
      const token = localStorage.getItem("token")
      if (!token) return

      checkIdleTime()

      if (localStorage.getItem("token")) {
        localStorage.setItem("last_activity", Date.now().toString())
        console.log("Activity updated")
      }
    }

    const events = [
      "mousemove",
      "mousedown",
      "click",
      "keydown",
      "scroll",
      "touchstart"
    ]

    events.forEach((event) => {
      document.addEventListener(event, updateActivity)
    })

    window.addEventListener("focus", checkIdleTime)
    window.addEventListener("pageshow", checkIdleTime)
    document.addEventListener("visibilitychange", checkIdleTime)

    ensureLastActivity()
    checkIdleTime()

    interval = setInterval(checkIdleTime, 1000)

    return () => {
      clearInterval(interval)

      events.forEach((event) => {
        document.removeEventListener(event, updateActivity)
      })

      window.removeEventListener("focus", checkIdleTime)
      window.removeEventListener("pageshow", checkIdleTime)
      document.removeEventListener("visibilitychange", checkIdleTime)
    }
  }, [dispatch])

  return children
}

export default IdleLogout